import axios from 'axios'
import { host } from '../../configuraciones'
import { v4 as uuidv4 } from 'uuid';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import moment from 'moment'

var fechaHoy = moment().format('YYYY-MM-DD');

//constantes
const dataInicial = {
    data: {},
    fc_33: {
        entregahologramas: false,
        emicioncertificadonomparaventan: false,
        inspeccionenvasadonacional: false,
        fechavisitapropuesta: fechaHoy,
        // fechasolicitud: fechaHoy,
        maquilador: false,
        propia: false,
        numerosocio: '',
        resposableinstalaciones: '',
        // numerocliente: '',
        correoelectronico: '',
        telefono: '',
        domicilioproducto: '',
        informacionadicionalsobreactivi: '',
        tipoinstalacion: ''
    },
    instalacionesCliente: [],
    marcasCliente: [],
    cliente: [],
    contadorDeFechaFolio: 0,
    loading: false,
    productos: [],
    fc_33Map: {},
    productosMap: [],
    paginaActiva: 1,
    modoEdicionBorrador: false,
    modoCorreccion: false,
    dataLogin: [],
    dataDocumentacion: {},
    files: [],
    filesProductos: [],
    instalacionesRelacionadas: [],
    relacionesCliente: [],
    filesMap: [],
    filesProductosMap: [],
    observacionesStatus: []
}

//types
const OBTENER_FC_33_DETALLE_EXITO = 'OBTENER_FC_33_DETALLE_EXITO'
const OBTENER_FC_33_MAP_EXITO = 'OBTENER_FC_33_MAP_EXITO'
const AGREGAR_FC_33_EXITO = 'AGREGAR_FC_33_EXITO'
const AGREGAR_FC_33_BORRADOR_EXITO = 'AGREGAR_FC_33_BORRADOR_EXITO'
const ACTUALIZAR_FC_33_ESTATUS_EXITO = 'ACTUALIZAR_FC_33_ESTATUS_EXITO'
const ELIMINAR_FC_33_SOLICITUD_EXITO_BD = 'ELIMINAR_FC_33_SOLICITUD_EXITO_BD'
const ELIMINAR_FC_33_ANEXOPRODUCTO_EXITO_BD = 'ELIMINAR_FC_33_ANEXOPRODUCTO_EXITO_BD'
const OBTENER_CLIENTE_POR_LOGIN_EXITO33 = 'OBTENER_CLIENTE_POR_LOGIN_EXITO33'
const OBTENER_FC_33_CONTADOR_FECHA_FOLIO_EXITO = 'OBTENER_FC_33_CONTADOR_FECHA_FOLIO_EXITO'
const ENVIAR_FC_33_BORRADOR_EXITO = 'ENVIAR_FC_33_BORRADOR_EXITO'
const AGREGAR_ARCHIVO_FC_33_EXITO = 'AGREGAR_ARCHIVO_FC_33_EXITO'
const ACTUALIZAR_ARCHIVO_FC_33_EXITO = 'ACTUALIZAR_ARCHIVO_FC_33_EXITO'
const OBTENER_INSTALACIONES_RELACIONADAS33_EXITO = 'OBTENER_INSTALACIONES_RELACIONADAS33_EXITO'
const ACTUALIZAR_FC_33_SOLICITUD = 'ACTUALIZAR_FC_33_SOLICITUD'
const AGREGAR_FC_33_FECHA_EXITO = 'AGREGAR_FC_33_FECHA_EXITO'

export const agregarFC_33Accion = createAsyncThunk(
    AGREGAR_FC_33_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos

            const agregarFC_33 = host + `FC_33/agregarNuevoFC_33SolicitudNacional`
            const urlAnexoProductos = host + 'FC_33/agregarFormatoFC33_AnexoProducto'

            const res = await axios.post(agregarFC_33, solicitud)

            let idfc33_solicitudenvasadonaciona = res.data.data.idfc33_solicitudenvasadonaciona
            for (let i in productos) {
                const { id, ...anexo } = productos[i]
                anexo.idfc33_solicitudenvasadonaciona = idfc33_solicitudenvasadonaciona
                const result = await axios.post(urlAnexoProductos, { data: anexo })
            }

            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const obtenerContadorDeFechaFolio = createAsyncThunk(
    OBTENER_FC_33_CONTADOR_FECHA_FOLIO_EXITO,
    async (year) => {
        try {
            const fullUrl = host + `Estatus/ContadorGeneralDeFechasFolio/year=${year}`
            const res = await axios.get(fullUrl)
            const contador =
                res.data.data.resultfc_01[0].count + res.data.data.resultfc_05[0].count + res.data.data.resultfc_06[0].count +
                res.data.data.resultfc_08[0].count + res.data.data.resultfc_09[0].count + res.data.data.resultfc_30[0].count +
                res.data.data.resultfc_31[0].count + res.data.data.resultfc_33[0].count + res.data.data.resultfc_34[0].count +
                res.data.data.resultfc_35[0].count + res.data.data.resultfc_36[0].count + res.data.data.resultfc_40[0].count +
                res.data.data.resultfc_41[0].count
            return contador
        } catch (error) {
            console.log(error)
        }
    }
)

export const ObtenerClientePorLogin33 = createAsyncThunk(
    OBTENER_CLIENTE_POR_LOGIN_EXITO33,
    async (params) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorLogin/${params.idlogin}`

            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            let idcartera = res.data.data.idcartera

            const fullUrlInstalaciones = host + `InformacionValida/obtenerAnexosCliente/${idcliente}`
            const fullUrlDatosLogin = host + `AnexoUsuario/obtenerDatosLoginPorCartera/${idcartera}`
            const fullUrlRelaciones = host + `AtencionAClientes/obtenerRelacionesPorIdCliente/${idcliente}`

            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            const resRelaciones = await axios.get(fullUrlRelaciones)
            let datos = []
            let marcas = []
            let instalaciones = []
            instalaciones.push(resinstalaciones.data.data)
            for (const marca of res.data.data.marcascliente) {
                if (marca.isbaja == false)  marcas.push(marca)
            }
            /*for (const marca of res.data.data.marcasproductoconmezcalcliente) {
                if (marca.isbaja == false) marcas.push(marca)
            }*/
            const resdatoslogin = await axios.get(fullUrlDatosLogin)
            let datosLogin = []
            datosLogin.push(resdatoslogin.data.data)
            datos.push(res.data.data, marcas, instalaciones, datosLogin, resRelaciones.data.data)
            return datos
        } catch (error) {
            console.log(error);
        }
    }
)
export const agregarFC_33SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_33_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos

            const agregarFC_33 = host + `FC_33/agregarNuevoFC_33SolicitudNacional`
            const urlAnexoProductos = host + 'FC_33/agregarFormatoFC33_AnexoProducto'

            const res = await axios.post(agregarFC_33, solicitud)
            let idfc33_solicitudenvasadonaciona = res.data.data.idfc33_solicitudenvasadonaciona

            for (let i in productos) {
                const { id, ...anexo } = productos[i]
                anexo.idfc33_solicitudenvasadonaciona = idfc33_solicitudenvasadonaciona
                const result = await axios.post(urlAnexoProductos, { data: anexo })
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const actualizarFC_33SolicitudBorrador = createAsyncThunk(
    AGREGAR_FC_33_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos
            let archivos = null

            if (data.archivos) {
                archivos = data.archivos
            }

            const actualizarFC_33 = host + `FC_33/actualizarFC_33SolicitudNacional`

            const urlAgregarAnexoProductos = host + 'FC_33/agregarFormatoFC33_AnexoProducto'
            const urlActualizarAnexoProductos = host + 'FC_33/actualizarFormatoFC33_AnexoProducto'

            const res = await axios.put(actualizarFC_33, solicitud)

            let idfc33_solicitudenvasadonaciona = res.data.data.idfc33_solicitudenvasadonaciona
            for (let i in productos) {
                if (productos[i].idfc33_anexoproducto) {
                    const { fc_33archivoproducto, id, ...anexo } = productos[i]
                    const resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                } else {
                    const { id, ...anexoProducto } = productos[i]
                    anexoProducto.idfc33_solicitudenvasadonaciona = idfc33_solicitudenvasadonaciona
                    await axios.post(urlAgregarAnexoProductos, { data: anexoProducto })
                }
            }
            return data
        } catch (error) {
            console.log(error)
        }
    }
)
export const eliminarFC_33SolicitudBD = createAsyncThunk(
    ELIMINAR_FC_33_SOLICITUD_EXITO_BD,
    async (id) => {
        try {
            const fullUrlSolicitud = host + `FC_33/eliminarFC_33SolicitudNacional/${id}`
            const resultDelete = await axios.delete(fullUrlSolicitud)
            return { id }
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_33SolicitudDetalle = createAsyncThunk(
    OBTENER_FC_33_DETALLE_EXITO,
    async (idSolicitud) => {
        try {
            const fullUrl = host + `FC_33/obtenerFormatoFC33_ConDetalle/${idSolicitud}`
            const res = await axios.get(fullUrl)
            console.log('asd ', idSolicitud)
            console.log('assafsdfd ', res.data.data)
            let instalacionesRelacionadasCliente = []
            if (res.data.data.maquilador) {
                const dato = res.data.data.numerosocio + ''
                let numSocio = ''
                if (dato.length === 1) numSocio = '0000' + dato
                if (dato.length === 2) numSocio = '000' + dato
                if (dato.length === 3) numSocio = '00' + dato
                if (dato.length === 4) numSocio = '0' + dato
                if (dato.length === 5) numSocio = '' + dato
                const fullUrlRelacion = host + `InformacionValida/obtenerClientePorNumSocio/${numSocio}`
                const clienteRelacion = await axios.get(fullUrlRelacion)
                const idcliente = clienteRelacion.data.data.idcliente
                const fullUrlInstalaciones = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
                const resinstalaciones = await axios.get(fullUrlInstalaciones)
                instalacionesRelacionadasCliente = resinstalaciones.data.data
            }

            const fc_33_anexoproducto = []
            const documentosProductos = []
            for (let i in res.data.data.fc_33_anexoproducto) {
                res.data.data.fc_33_anexoproducto[i]['id'] = uuidv4()
                for (const j in res.data.data.fc_33_anexoproducto[i].fc_33archivoproducto) {
                    const { ...anexo } = res.data.data.fc_33_anexoproducto[i].fc_33archivoproducto[j]
                    const data = {
                        id: anexo.nameid,
                        file: { name: await getNameFile(anexo.ruta) },
                        idAnexo: anexo.idfc_33archivoproducto,
                        // idAnexoBD: anexo.idfc_33archivoproducto,
                        idAnexoFK: res.data.data.fc_33_anexoproducto[i].idfc33_anexoproducto,
                        estatus: true,
                    }

                    documentosProductos.push(data)
                }
            }
            fc_33_anexoproducto.push({ data: res.data.data.fc_33_anexoproducto })

            const documentosFC_33 = []
            //FILES
            for (const i in res.data.data.fc_33archivos) {
                const { ...anexo } = res.data.data.fc_33archivos[i]
                const data = {
                    id: anexo.nameid,
                    file: { name: await getNameFile(anexo.ruta) },
                    idAnexo: anexo.idfc_33archivos,
                    idAnexoFK: res.data.data.idfc33_solicitudenvasadonaciona,
                    estatus: true,
                }

                documentosFC_33.push(data)
            }
            if (res.data.data.fechavisitapropuesta) {
                let fecha = res.data.data.fechavisitapropuesta
                res.data.data.fechavisitapropuesta = moment(fecha).add(1, 'd').format('YYYY-MM-DD')
            }

            return { data: res.data.data, fc_33_anexoproducto, documentosFC_33, documentosProductos, instalacionesRelacionadasCliente }
        } catch (error) {
            console.log(error);
        }
    }
)
export const obtenerFC_33Map = createAsyncThunk(
    OBTENER_FC_33_MAP_EXITO,
    async (solicitudId) => {
        try {
            const fullUrl = host + `MapSolicitud/obtenerMapFC_33_Solicitud/${solicitudId}`
            const res = await axios.get(fullUrl)
            let mapFiles = []
            let productosMap = []
            let filesProductosMap = []
            let observacionesGeneral = 0
            let observacionesProductos = 0
            let observacionesFilesProductos = 0

            const Map = await obtenerProductosMap(solicitudId)
            productosMap.push(Map.anexoProductoMap)
            //mapFiles.push(Map.filesGeneralMap)
            filesProductosMap.push(Map.filesProductosMap)

            for (const i in res.data.data) {
                if (res.data.data[i] === true) observacionesGeneral++
            }
            for (const i in productosMap[0]) {
                if (productosMap?.[0]?.[i]?.productocheck === true) observacionesProductos++
            }
            for (const i in filesProductosMap[0]) {
                if (filesProductosMap?.[0]?.[i]?.estatuscheck === true) observacionesFilesProductos++
            }
            let observacionesStatus = { observacionesGeneral: observacionesGeneral, observacionesProductos: observacionesProductos, observacionesFilesProductos: observacionesFilesProductos }
            const solicitudMap = {
                data: res.data.data,
                //mapFiles: mapFiles,
                productosMap: productosMap,
                filesProductosMap: filesProductosMap,
                observacionesStatus: observacionesStatus
            }
            return solicitudMap
        } catch (error) {
            console.log(error)
        }
    }
)
const obtenerProductosMap = async (idSolicitud) => {
    try {
        const fullUrl = host + `FC_33/obtenerFormatoFC33_ConDetalle/${idSolicitud}`
        const obtenerProductoMap = host + `MapSolicitud/obtenerMapFC_33_AnexoProducto/`
        const obtenerArchivosGeneralMap = host + `MapSolicitud/obtenerMapFC_33_ArchivosGenerales/`
        const obtenerArchivoProductoMap = host + `MapSolicitud/obtenerMapFC_33_ArchivosProductos/`
        const res = await axios.get(fullUrl)
        const filesGeneral = res.data.data.fc_33archivos
        const filesProductos = res.data.data.fc_33_anexoproducto
        {/*const filesGeneralMap = []
        for (const i in filesGeneral) {
            const resfiles = await axios.get(obtenerArchivosGeneralMap + filesGeneral[i].idfc_33archivos)
            if (resfiles.data.data) {
                resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_33archivos
                resfiles.data.data.nameid = ""
                filesGeneralMap.push(resfiles.data.data)
            }
        }*/}

        const filesProductosMap = []
        for (const producto of filesProductos) {
            for (const archivo of producto.fc_33archivoproducto) {
                const resfiles = await axios.get(obtenerArchivoProductoMap + archivo.idfc_33archivoproducto)
                if (resfiles.data.data) {
                    resfiles.data.data.idAnexoBD = resfiles.data.data.idfc_33archivoproducto
                    filesProductosMap.push(resfiles.data.data)
                }
            }
        }
        // const filesProductos = res.data.data
        let anexoProductoMap = []
        for (const anexo of res.data.data.fc_33_anexoproducto) {
            const resMap = await axios.get(obtenerProductoMap + anexo.idfc33_anexoproducto)
            anexoProductoMap.push(resMap.data.data)

        }
        let Map = { anexoProductoMap: anexoProductoMap, filesProductosMap: filesProductosMap }
        return Map
    } catch (error) {
        console.log(error);
    }
}
export const actualizarFC_33Solicitud = createAsyncThunk(
    ACTUALIZAR_FC_33_SOLICITUD,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = { data: data.productos }
            const actualizarFC_33 = host + `FC_33/actualizarFC_33SolicitudNacional`
            const urlActualizarAnexoProductos = host + 'FC_33/actualizarFormatoFC33_AnexoProducto'

            const res = await axios.put(actualizarFC_33, solicitud)

            for (let i in productos.data) {
                if (productos.data[i].idfc33_anexoproducto) {
                    const { fc_33archivoproducto, id, ...anexo } = productos.data[i]
                    const resAnexo = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                }
            }

            return res
        } catch (error) {
            console.log(error)
        }
    }
)

const getNameFile = async (ruta) => {
    let nameFile = null
    const array = ruta.split("/")
    // const array = ruta.split("\\")//local
    nameFile = array[array.length - 1]
    return nameFile
}
export const enviarBorradorFC_33 = createAsyncThunk(
    ENVIAR_FC_33_BORRADOR_EXITO,
    async (data) => {
        try {
            const solicitud = { data: data.solicitud }
            const productos = data.productos

            const actualizarFC_33 = host + `FC_33/actualizarFC_33SolicitudNacional`
            const urlAgregarAnexoProductos = host + 'FC_33/agregarFormatoFC33_AnexoProducto'
            const urlActualizarAnexoProductos = host + 'FC_33/actualizarFormatoFC33_AnexoProducto'

            const res = await axios.put(actualizarFC_33, solicitud)
            let idfc33_solicitudcertificado = res.data.data.idfc33_solicitudcertificado

            /*Acciones para anexo productos*/
            for (let i in productos) {
                const { id, fc_33archivoproducto, ...anexo } = productos[i]
                let resAnexoId = null
                if (productos[i].idfc33_anexoproducto) {
                    const result = await axios.put(urlActualizarAnexoProductos, { data: anexo })
                    resAnexoId = result.data.data.idfc33_anexoproducto
                } else {
                    anexo.idfc33_solicitudcertificado = idfc33_solicitudcertificado
                    const result = await axios.post(urlAgregarAnexoProductos, { data: anexo })
                    resAnexoId = result.data.data.idfc33_anexoproducto
                }
            }
            return res
        } catch (error) {
            console.log(error)
        }
    }
)
export const agregarFileFC_33 = createAsyncThunk(
    AGREGAR_ARCHIVO_FC_33_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await agregarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const agregarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexoFK)
    const resFile = await axios.post(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const actualizarFileFC_33 = createAsyncThunk(
    ACTUALIZAR_ARCHIVO_FC_33_EXITO,
    async (data) => {
        try {
            const { archivo, ruta } = data
            const result = await actualizarFile(archivo, ruta)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)
const actualizarFile = async (data, url) => {
    let formData = new FormData();
    formData.append(1, data.file)
    formData.append('nameId', data.id)
    formData.append('idSolicitud', data.idAnexo)
    formData.append('idSolicitudFK', data.idAnexoFK)
    // formData.append('idfc_33archivos', data.idAnexoBD)
    const resFile = await axios.put(host + url, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    return resFile
}
export const ObtenerInstalacionesRelacionadas = createAsyncThunk(
    OBTENER_INSTALACIONES_RELACIONADAS33_EXITO,
    async (numerosocio) => {
        try {
            const fullUrl = host + `InformacionValida/obtenerClientePorNumSocio/${numerosocio}`
            const res = await axios.get(fullUrl)
            let idcliente = res.data.data.idcliente
            const fullUrlInstalaciones = host + `InformacionValida/obtenerInstalacionesRelacionadas/${idcliente}`
            const resinstalaciones = await axios.get(fullUrlInstalaciones)
            return resinstalaciones.data.data
        } catch (error) {
            console.log(error);
        }
    }
)

export const actualizarFC_33Estatus = createAsyncThunk(
    ACTUALIZAR_FC_33_ESTATUS_EXITO,
    async (data) => {
        try {
            const fullUrl = host + 'Estatus/actualizarEstatusTablas'
            const result = await axios.post(fullUrl, data)
            return result
        } catch (error) {
            console.log(error);
        }
    }
)

export const eliminarFC_33AnexoProductoBD = createAsyncThunk(
    ELIMINAR_FC_33_ANEXOPRODUCTO_EXITO_BD,
    async (id) => {
        try {
            const fullUrl = host + `FC_33/eliminarFormatoFC33_AnexosProducto/${id}`
            await axios.delete(fullUrl)
            return id
        } catch (error) {
            console.log(error);
        }
    }
)
export const actualizarFC_33Fecha = createAsyncThunk(
    AGREGAR_FC_33_FECHA_EXITO,
    async (data) => {
        try {
            const actualizarFC_33 = host + `FC_33/actualizarFC_33SolicitudNacional`

            const res = await axios.put(actualizarFC_33, { data: data })
            return res.data.data
        } catch (error) {
            console.log(error)
        }
    }
)
export const fc33Slice = createSlice({
    name: 'fc33Slice',
    initialState: dataInicial,
    reducers: {
        guardarCambiosFC_33SolicitudBorrador(state, { payload }) {
            state.data = payload
        },
        guardarCambiosFC_33SolicitudNueva(state, { payload }) {
            state.fc_33 = payload
        },
        agregarFC_33AnexoProducto(state, { payload }) {
            state.productos = payload
        },
        agregarFC_33Producto(state, { payload }) {
            state.productos.data.push(payload)
        },
        actualizarFC_33PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        actualizarModoBorradorFC_33(state, { payload }) {
            state.modoEdicionBorrador = payload
        },
        actualizarModoCorrecionFC_33(state, { payload }) {
            state.modoCorreccion = payload
        },
        actualizarFC_33PaginaActiva(state, { payload }) {
            state.paginaActiva = payload
        },
        editarFC_33AnexoProducto(state, { payload }) {
            const input = state.productos.data.filter(field => field.id === payload.id)
            if (input.length > 0) {
                input[0][payload.campo] = payload.valor
            }
        },
        resetDataFC_33(state, { payload }) {
            return dataInicial
        },
    },
    extraReducers: {
        [ObtenerClientePorLogin33.fulfilled]: (state, { payload }) => {
            state.cliente = payload[0]
            state.marcasCliente = payload[1]
            state.instalacionesCliente = payload[2][0]
            state.dataLogin = payload[3][0][0]
            state.relacionesCliente = payload[4]
        },
        [obtenerContadorDeFechaFolio.fulfilled]: (state, { payload }) => {
            state.contadorDeFechaFolio = payload
        },
        [agregarFC_33Accion.fulfilled]: (state, { payload }) => {
        },

        [obtenerFC_33SolicitudDetalle.fulfilled]: (state, { payload }) => {
            state.data = payload.data
            state.fc_33 = payload.data
            state.dataDocumentacion = payload.data
            state.productos = { data: payload.data.fc_33_anexoproducto }
            state.files = { data: payload.documentosFC_33 }
            state.filesProductos = { data: payload.documentosProductos }
            state.instalacionesRelacionadas = payload.instalacionesRelacionadasCliente

        },
        [obtenerFC_33Map.fulfilled]: (state, { payload }) => {
            state.fc_33Map = payload.data
            state.productosMap = payload.productosMap[0]
            //state.filesMap = payload.mapFiles[0]
            state.filesProductosMap = payload.filesProductosMap[0]
            state.observacionesStatus = payload.observacionesStatus
        },
        [agregarFC_33SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_33SolicitudBorrador.fulfilled]: (state, { payload }) => {
        },
        [actualizarFC_33Estatus.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_33SolicitudBD.fulfilled]: (state, { payload }) => {
        },
        [eliminarFC_33AnexoProductoBD.fulfilled]: (state, { payload }) => {
            const filtro = { data: state.productos.data.filter(anexo => anexo.idfc33_anexoproducto !== payload) }
            state.productos = filtro
        },
        [agregarFileFC_33.fulfilled]: (state, { payload }) => {
        },
        [actualizarFileFC_33.fulfilled]: (state, { payload }) => {
        },
        [ObtenerInstalacionesRelacionadas.fulfilled]: (state, { payload }) => {
            state.instalacionesRelacionadas = payload
        },
    },
})

//actions
export const {
    guardarCambiosFC_33SolicitudBorrador,
    guardarCambiosFC_33SolicitudNueva,
    agregarFC_33AnexoProducto,
    agregarFC_33Producto,
    actualizarModoBorradorFC_33,
    actualizarModoCorrecionFC_33,
    actualizarFC_33PaginaActiva,
    editarFC_33AnexoProducto,
    resetDataFC_33,
} = fc33Slice.actions

export const FC33ReducerBeneficiario = fc33Slice.reducer